/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserFollowingProfile } from '../../models/user-following-profile';

export interface GetUserFollowingProfiles$Params {

/**
 * Id of user.
 */
  id: number;
}

export function getUserFollowingProfiles(http: HttpClient, rootUrl: string, params: GetUserFollowingProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserFollowingProfile>>> {
  const rb = new RequestBuilder(rootUrl, getUserFollowingProfiles.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserFollowingProfile>>;
    })
  );
}

getUserFollowingProfiles.PATH = '/rest/user/{id}/profile/following';
